import { SchemaCRUD } from '@/components/crud/SchemaCRUD';

const Contracts = () => {
	return (
		<SchemaCRUD
			entity="contracts"
			title="Contratos Inteligentes"
			description="Gerenciar contratos inteligentes implantados"
			apiEndpoint="v1/admin/contracts"
		/>
	);
};

export default Contracts;
